module.exports = __webpack_public_path__ + "static/media/bus-icon.e8e0a2a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/bus-icon.svg
// module id = 834
// module chunks = 0